// extracted by mini-css-extract-plugin
export var chevronIcon = "_d5-2";
export var teamName = "_d5-1";
export var teamSwitcherButton = "_d5-0";